import { useMap } from 'react-leaflet';
import { useEffect } from 'react';
import L from 'leaflet';

function Routing({ origem, destino }) {
  const map = useMap();

  useEffect(() => {
    // Injeta o CSS para esconder instruções detalhadas e manter só resumo visível
    const style = document.createElement('style');

    // esconder detalhes da navegação... direita, esquerda, etc
    style.innerHTML = `
        
      .leaflet-routing-container table tbody {
        display: none !important;
      }

    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    if (!map || !origem || !destino) return;

    const routingControl = L.Routing.control({
      waypoints: [
        L.latLng(origem[0], origem[1]),
        L.latLng(destino[0], destino[1])
      ],
      lineOptions: {
        styles: [{ color: '#0d6efd', weight: 5 }],
      },
      createMarker: () => null,
      addWaypoints: false,
      routeWhileDragging: false,
      draggableWaypoints: false,
      fitSelectedRoutes: true,
      show: false,
    }).addTo(map);

    return () => {
      map.removeControl(routingControl);
    };
  }, [map, origem, destino]);

  return null;
}

export default Routing;
